import {
  ChangeDetectionStrategy,
  Component,
  output,
  inject,
} from '@angular/core';

import { HttpErrorService } from '@web/common';
import { AlertsComponent, AlertsService } from '@web/shared/ui';
import { AdminBoxDataSourceService } from '../../services/admin-box-data-source.service';
import { once } from '@web/utils';
import { HttpErrorResponse } from '@angular/common/http';
import { AdminBoxDetailsForm } from '../../models/admin-box-details-form';
import { AdminBoxDetailsFormComponent } from '../admin-box-details-form/admin-box-details-form.component';

@Component({
  selector: 'app-admin-box-create',
  imports: [AlertsComponent, AdminBoxDetailsFormComponent],
  templateUrl: './admin-box-create.component.html',
  styleUrl: './admin-box-create.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [AlertsService],
})
export class AdminBoxCreateComponent {
  private readonly boxDataSource = inject(AdminBoxDataSourceService);
  private readonly httpError = inject(HttpErrorService);
  private readonly alerts = inject(AlertsService);

  public readonly submitSuccessEvent = output<void>();

  public handleSubmitClickEvent(data: AdminBoxDetailsForm): void {
    this.boxDataSource
      .createByFormData(data)
      .pipe(once())
      .subscribe({
        next: () => this.notifySubmitSuccessEvent(),
        error: (response) => this.showFailureAlertByResponse(response),
      });
  }

  private notifySubmitSuccessEvent(): void {
    this.submitSuccessEvent.emit();
  }

  private showFailureAlertByResponse(response: HttpErrorResponse): void {
    const messages = this.httpError.extract(response).messages();

    this.alerts.showMultiple((builder) =>
      messages.map((message) => builder.buildFailure(message)),
    );
  }
}
